export const DEFAULT_PORTFOLIO_PREFIX = 'Top Level Owner';

export const SECURITY_GROUPING = 'security';

export const DEFAULT_GROUPINGS = ['top_level_owner', 'asset_class', 'roll_up', SECURITY_GROUPING];

export const DEFAULT_RETURN_KEY = 'time_weighted_return';

// The attribute lives in the customer's own Addepar tenant, so we cannot rename it on their behalf.
// Every brand's name is accepted in every build: a customer who renamed theirs after the rebrand
// must still match when served the pre-rebrand UI, and vice versa.
// 'RiskPro Return' is the no-space brand spelling the backend has accepted since VEN-123; the IT
// guide asks clients for 'Risk Pro Return'. Keep this list identical to RETURNS_DISPLAY_NAMES in
// venn-backend AddeparConstants - this list decides which column the user is offered, that one
// decides which column the sync reads, and a mismatch silently falls back to the adjusted TWR.
export const CUSTOM_RETURN_ATTRIBUTE_NAMES = ['Venn Return', 'RiskPro Return', 'Risk Pro Return'];
